<template>
  <div class="jigsaw">
     <h1  :class="[goActiveFlag?'goActive':'','word-go']" @animationend="gameBegin" v-if="!timeoutShow">Ready Go</h1>

     <!-- <audio src="../../assets/audio/bgmusic.mp3" id="bgmusic" ref="bgmusic" loop  autoplay controls></audio>
     <audio src="../../assets/audio/go.mp3" id="go" ref="go" v-if="!timeoutShow" ></audio> -->
     <div class="jigsaw_top">
        <div class="jigsaw_top_left">
            <img src="@/assets/images/jigsaw/back.png" class="jigsaw_top_back" @click="back">
            <div class="jigsaw_top_guanqia">
               <p class="jigsaw_top_guanqia_title">关卡</p>
               <p class="jigsaw_top_guanqia_level" v-if="current >= 10">{{current}}</p>
               <p class="jigsaw_top_guanqia_level" v-else>0{{current}}</p>
            </div>
        </div>
        <div class="jigsaw_top_right">
           <div class="jigsaw_top_rules">
            <span class="jigsaw_top_rules_title">请在{{gameLevelData.limitTime}}s内完成1次<span class="jigsaw_emotion">{{gameLevelData.emotion}}</span>表情大拼接</span>
            <img src="@/assets/images/jigsaw/cartoon.png" class="jigsaw_top_rules_pic"/>
         </div>
         <div class="jigsaw_top_times">
            <img :src="require(`@/assets/images/jigsaw/${gamePauseFlag ? 'pause.png' : 'start.png'}`)" class="jigsaw_top_switch" @click="stateChange">
            <div class="jigsaw_top_time">{{limitTime}}</div>
         </div>
        </div>
     </div>
     <div class="jigsaw_bottom">
        <div class="jigsaw_bottom_game">
           <div class="jigsaw_bottom_game_left" :class="gameLevelData.className">
              <p class="jigsaw_bottom_game_title">选择区</p>
              <div class="jigsaw_bottom_game_left_area" >
                 <div :class="'jigsaw_bottom_game_left_dragging jigsaw_bottom_game_left_area_'+gameLevelData.className">
                     <div v-for="index in gameLevelData.row" :key="index" class="finished_row" :id="'row_'+index">
                           <div v-for="ject in gameLevelData.cloumn" :key="index+ject" class="finished_cloumn"
                           @touchstart="onTouchstart"
                           :id="'cloumn_'+index+ject"
                           ></div>
                           <!-- " -->
                           <!-- @touchmove="onTouchmove" -->
                           <!-- @touchend="onTouchend" -->
                     </div>
                  </div>
              </div>
           </div>
           <div class="jigsaw_bottom_game_right" :class="gameLevelData.className">
              <p class="jigsaw_bottom_game_title">完成区</p>
              <div class="jigsaw_bottom_game_right_area" >
                 <div class="area_img" :class="'emotion'+gameLevelData.emotionNum"></div>
                 <!-- <img :src="gameLevelData[localIndex].img" class="area_one" :style="{'width':gameLevelData[localIndex].width+'px','height':gameLevelData[localIndex].height+'px'}"/> -->
                 <div :class="'jigsaw_bottom_game_right_place jigsaw_bottom_game_right_area_'+gameLevelData.className" >
                    <p v-for="index in gameLevelData.row" :key="index" :class="'finished_row row_'+index " >
                          <span v-for="ject in gameLevelData.cloumn" :key="index+ject" :class="'finished_cloumn cloumn_'+index+ject"
                          ></span>
                    </p>
                 </div>
              </div>
           </div>
        </div>
     </div>
     <!-- 通关弹窗 -->
     <passed-dialog
     :passedShow="passedShow"
     :nextFlag="nextFlag"
     @next="next"
     @goBack="goBack"></passed-dialog>
     <!-- 返回提醒弹窗 -->
     <goback-info :infoShow="goBackShow" :infoMsg="infoMsg" @infoClose="infoClose" @goback="goBack"></goback-info>
      <!-- 游戏失败提醒弹窗 -->
      <fail-info :infoShow="failShow" :infoMsg="failMsg"  @restart="restart" @goback="goBack"></fail-info>
      <!-- 暂停提示框 -->
      <pause-info :infoShow="pauseShow" :infoMsg="pauseMsg"  @goback="goBack" @restart="restart" @start="gameBegin" ></pause-info>
      <!-- wrong提示框 -->
      <wrong-info :infoShow="wrongShow" :infoMsg="wrongMsg"></wrong-info>
      <!-- 超时提示框 -->
      <timeout-info :infoShow="timeoutShow" :infoMsg="timeoutMsg" @goback="goBack"></timeout-info>
  </div>
</template>

<script>
import passedDialog from '../../components/jigsaw/passed-dialog.vue';
import gobackInfo from './../../components/game/goback-info.vue';
import failInfo from './../../components/game/fail-info.vue';
import pauseInfo from './../../components/game/pause-info.vue';
import wrongInfo from '../../components/jigsaw/wrong-info.vue';
import timeoutInfo from "../../components/jigsaw/timeout-info.vue";
import { dateFormat } from '../../assets/js/util.js';
import {horizontalScreen} from '../../assets/js/horizontal';
import {
    _getPlayTimeLimit, // 获取游戏可玩时长
   _getGameStart, // 标识游戏开始
   _setGameLevel, // 设置游戏关卡
   _getGameEnd,
   _getWrong, // 设置游戏错误记录
} from '../../api/game';
import { Toast } from 'vant';
export default {
   name:"jigsaw",
   components:{
      passedDialog,
      gobackInfo,
      failInfo,
      pauseInfo,
      wrongInfo,
      timeoutInfo
   },
   data() {
      return {
         limitTime:"",// 通关时间限制
         emotion:'开心',// 情绪
         current:13, // 当前关卡
         // localIndex:0,//默认9宫格
         gameLevelData:{
            className:"",
            emotion:"",
            cloumn:null,
            row:null,
            limitTime:null,
         },
         passedShow:false,// 是否通关
         goBackShow:false, // 是否展示返回提醒弹窗
         failShow:false, // 是否展示游戏失败提醒弹窗
         wrongShow:false,//是否展示错误提示框
         pauseShow:true,// 是否展示暂停弹框
         timeoutShow:false,// 是否展示超过一小时提示框
         wrongMsg:"wrong~",// 错误提示话术
         infoMsg:'还没完成哦，确定要退出吗',//退出话语
         failMsg:'时间到了，再试一次吧～',//失败话术
         pauseMsg:"休息一下吧~",//暂停话术
         timeoutMsg:"您已经持续一个小时玩游戏了,该让眼睛休息啦,还想玩的话,请明天再来吧！",
         dragFlag:false,// 拖动是否开始
         dragNum:0,//拖动次数
         startX:0,// 拖拽碎片开始的pageX位移值
         startY:0,// 拖拽碎片开始的pageY位移值
         targetTop:0, // 目标位移的top
         targetLeft:0, // 目标位移的left
         curTop:0,//滑动未开始时碎片的位置
         curLeft:0,//滑动未开始时碎片的位置
         goActiveFlag:false,//游戏readygo是否展示
         timer:null,//倒计时计时器
         intervalTimer:null,//获取游戏可玩时长计时器
         gamePauseFlag:false,// 游戏是否暂停
         intervalTime:60000,//刷新接口获取时间游戏可玩时长的间隔时间
         resetTime:0,// 剩余游戏可玩时长,单位（S）
         childId:'',// 儿童ID
         imgWidth:null,//碎片图片的宽度
         imgHeight:null,//碎片图片的高
         rightTopHeight:null,//完成区图片离顶部的距离
         leftTopHeight:null,//选择区碎片离框顶部的距离
         fWidth:null,//选择区宽度
         isMoveShow:[],// 是否可以拖拽
         curSpan:null, // 当前拖动的盒子
         identifier:null,// 标识触摸的唯一ID
         wrongId:'',//拼图的错误编号
      }
   },
   watch:{},
   created() {
      this.childId = localStorage.getItem('childId')
      this.current = Number(localStorage.getItem('jigsawLevel'));
      // 游戏开始记录
      this.queryBeginTime();
      var app=document.getElementById("app");
    	var touchstartY;
    	app.addEventListener("touchstart",function(event){
    		var events=event.touches[0]||event;
    		touchstartY=events.clientY;//获取触摸目标在视口中的y坐标
    	},false);
    	app.addEventListener("touchmove",function(event){
    		var events=event.touches[0]||event;
    		//注意document.body.scrollTop始终为0
    		var scrollTop=document.body.scrollTop||document.documentElement.scrollTop;//获取滚动部分的高度
    		var clientHeight=document.documentElement.clientHeight;//获取手机屏幕高度（可视部分高度）
    		var scrollHeight=document.body.scrollHeight;//所有内容的高度
    		if(events.clientY>touchstartY&&scrollTop===0&&event.cancelable){
    			event.preventDefault();//禁止到顶下拉
    		}else if(scrollTop+clientHeight>scrollHeight&&event.cancelable){
    			event.preventDefault();//禁止到底上拉
    		}
    	},false);

   },
   computed:{
      // 是否显示下一关按钮
      nextFlag:function() {
         let flag = true;
         if(this.current >= 16){
            flag = false;
         }
         return flag;
      },
      // 可视区域宽度(原点为左上角) 375
      clientWidth:function() {
         return document.documentElement.clientWidth;
      },
      // 可视区域高度(原点为左上角) 667
      clientHeight:function() {
         return document.documentElement.clientHeight;
      },
      // 包含选择区和完成区的宽度 (原点为右上角)
      parentW:function() {
         return document.getElementsByClassName('jigsaw_bottom_game')[0].clientWidth
      },
      // 包含选择区和完成区高度(原点为右上角)
      parentH:function() {
         return document.getElementsByClassName('jigsaw_bottom_game')[0].clientHeight
      },
      // 游戏区域离顶部的高度(原点为右上角)
      boxTopW:function() {
         return document.getElementsByClassName('jigsaw_top')[0].clientHeight
      },
      // 游戏区域边框值(原点为右上角)
      borderW:function() {
         return (document.getElementsByClassName('jigsaw_bottom')[0].clientHeight - document.getElementsByClassName('jigsaw_bottom_game')[0].clientHeight) / 2
      },

   },
   beforeDestroy() {
      clearInterval(this.intervalTimer)
   },
   mounted() {
      document.getElementsByClassName('jigsaw')[0].style.width = document.body.clientHeight + 'px';
      document.getElementsByClassName('jigsaw')[0].style.height = document.body.clientWidth + 'px';
      horizontalScreen(); // 横屏
      this.getInit()
      
      // this.$refs.bgmusic.play();
      // this.$refs.go.play();
      this.goActiveFlag = true;
   },
   methods:{
      // 游戏报错，保存报错记录
      saveWrong(wrongBlock) {
         let params = {
            currentLevel:this.current,
            gameType: 0,
            studentId:this.childId,
            rightBlock:this.gameLevelData.emotionNum,
            wrongBlock: wrongBlock
         }
         _getWrong(params).then(res=>{
            if(res.code != 200){
               Toast({message:res.message,className:'rotation'})
            }
         })
      },
      // 游戏结束，保存关卡
      saveGameLevel(currentLevel,isCurrentPassed) {
         let params = {
            currentLevel:currentLevel,
            gameType:'0',
            isCurrentPassed:isCurrentPassed,
            studentId:this.childId
         }
         _setGameLevel(params).then(res=>{
            if(res.code == 200){
               localStorage.setItem('jigsawLevel',currentLevel)
               localStorage.setItem('jigsawSuccessFlag',true)
            }else{
               Toast({message:res.message,className:'rotation'})
            }
         })
      },
      // 记录游戏结束
      queryGameEnd() {
         let params = {
            currentLevel:this.current,
            gameType:0,
            studentId: this.childId
         }
         _getGameEnd(params)
      },
      // 获取游戏可玩时长
      queryGameLimitTime() {
         _getPlayTimeLimit({studentId:this.childId}).then(res=>{
            if(res.code == 200){
               this.resetTime = res.data
               if(this.resetTime == 0){
                  // 超时弹框提醒
                  this.timeoutShow = true
                  clearInterval(this.timer)
                  clearInterval(this.intervalTimer)
               }else{
                  // this.$nextTick(()=>{
                  //    this.$refs.bgmusic.play();
                  //    this.$refs.go.play();
                  //    this.goActiveFlag = true;
                  // })

               }
            }
         })
      },
      // 标记游戏开始
      queryBeginTime() {
         let params = {
            currentLevel:this.current,
            gameType:0,
            studentId: this.childId
         }
         _getGameStart(params).then(res=>{
            if(res.code == 200){
               // // 获取游戏时长
               this.queryGameLimitTime();
               this.intervalTimer = setInterval(()=>{
                  this.queryGameLimitTime();
               },this.intervalTime)

            }else if(res.code == 1010003){
               // 超时弹框提醒
               this.timeoutShow = true;
               clearInterval(this.timer);
               clearInterval(this.intervalTimer);
            } else if(res.code ==  1010002){
               // // 获取游戏时长
               this.queryGameLimitTime();
               this.intervalTimer = setInterval(()=>{
                  this.queryGameLimitTime();
               },this.intervalTime)
               // this.$nextTick(()=>{
               //    this.$refs.bgmusic.play();
               //    this.$refs.go.play();
               //    this.goActiveFlag = true;
               // })
            }else {
               Toast({message:res.message,className:'rotation'});
            }
         })
      },
      // 游戏初始化
      getInit() {
         this.dragNum = 0;
         // 1，5，9，13是愉快；2，6，10，14是悲伤；3，7，11，15是害怕，4，8，12，16是伤心
         let emotionNum = null; // 当前表情是哪一个：1:愉快 2:悲伤 3:害怕 4:伤心
         let n = null; // 当前拼图处于多少块的图：1：9块 2：12块 3：15块 4：20块
         this.gameLevelData = {
            className:"",
            emotion:"",
            cloumn:null,
            row:null,
            limitTime:null,
            emotionNum:null,
            img:null,
         }
         if(this.current > 4){
            emotionNum = this.current % 4 == 0 ? 4 : this.current % 4;
            n = (this.current - emotionNum)/4 + 1;
         }else{
            emotionNum = this.current;
            n = 1
         }
         this.gameLevelData.emotionNum = emotionNum;
         if(n == 1){
            this.gameLevelData.className = 'one';
            this.gameLevelData.limitTime = 45;
            this.gameLevelData.cloumn = 3;
            this.gameLevelData.row = 3;
            if(emotionNum == 1){
               this.gameLevelData.img = require('../../assets/images/jigsaw/happy1.png');
            }else if(emotionNum == 2){
               this.gameLevelData.img = require('../../assets/images/jigsaw/sorrow1.png');
            }else if(emotionNum == 3){
               this.gameLevelData.img = require('../../assets/images/jigsaw/scare1.png');
            }else if(emotionNum == 4){
               this.gameLevelData.img = require('../../assets/images/jigsaw/anger1.png');
            }
         }else if(n == 2){
            this.gameLevelData.className = 'two';
            this.gameLevelData.limitTime = 70;
            this.gameLevelData.cloumn = 4;
            this.gameLevelData.row = 3;
            if(emotionNum == 1){
               this.gameLevelData.img = require('../../assets/images/jigsaw/happy2.png');
            }else if(emotionNum == 2){
               this.gameLevelData.img = require('../../assets/images/jigsaw/sorrow2.png');
            }else if(emotionNum == 3){
               this.gameLevelData.img = require('../../assets/images/jigsaw/scare2.png');
            }else if(emotionNum == 4){
               this.gameLevelData.img = require('../../assets/images/jigsaw/anger2.png');
            }
         }else if( n == 3){
            this.gameLevelData.className = 'three';
            this.gameLevelData.limitTime = 90;
            this.gameLevelData.cloumn = 5;
            this.gameLevelData.row = 3;
            if(emotionNum == 1){
               this.gameLevelData.img = require('../../assets/images/jigsaw/happy3.png');
            }else if(emotionNum == 2){
               this.gameLevelData.img = require('../../assets/images/jigsaw/sorrow3.png');
            }else if(emotionNum == 3){
               this.gameLevelData.img = require('../../assets/images/jigsaw/scare3.png');
            }else if(emotionNum == 4){
               this.gameLevelData.img = require('../../assets/images/jigsaw/anger3.png');
            }
         }else if(n == 4){
            this.gameLevelData.className = 'four';
            this.gameLevelData.limitTime = 150;
            this.gameLevelData.cloumn = 5;
            this.gameLevelData.row = 4;
            if(emotionNum == 1){
               this.gameLevelData.img = require('../../assets/images/jigsaw/happy4.png');
            }else if(emotionNum == 2){
               this.gameLevelData.img = require('../../assets/images/jigsaw/sorrow4.png');
            }else if(emotionNum == 3){
               this.gameLevelData.img = require('../../assets/images/jigsaw/scare4.png');
            }else if(emotionNum == 4){
               this.gameLevelData.img = require('../../assets/images/jigsaw/anger4.png');
            }
         }
         if(emotionNum == 1){
            this.gameLevelData.emotion = "愉快";
         }else if(emotionNum == 2){
            this.gameLevelData.emotion = "悲伤";
         }else if(emotionNum == 3){
            this.gameLevelData.emotion = "害怕";
         }else if(emotionNum == 4){
            this.gameLevelData.emotion = "伤心";
         }
         // this.gameLevelData.map((item,index)=>{
         //    if(this.current >= item.min && this.current <= item.max){
         //       this.localIndex = index;
         //    }
         // })
         this.timeRemap();

         this.$nextTick(()=>{
           this.addImg(this.gameLevelData);
         })
         // this.$refs.bgmusic.play();
         // this.$refs.go.play();
         // this.goActiveFlag = true;
      },
      // 时间重置
      timeRemap() {
         if(this.gameLevelData.limitTime > 60){
            let num = Math.floor(this.gameLevelData.limitTime/60);
            let time = this.gameLevelData.limitTime % 60;
            this.limitTime = num + ":" + time;
         }else{
            this.limitTime = "0:"+this.gameLevelData.limitTime;
         }
         clearInterval(this.timer)
      },
      // 判断是否只有一个触摸点
      processEvent(e) {
         if(e.changedTouches){
            // 单点触控
            let currentTouch = null;
            if(e.type == 'touchstart'){
               // 假如当前无触摸点，则新建一个
               if(this.identifier == null){
                  this.identifier = e.changedTouches[0].identifier;
                  currentTouch = e.changedTouches[0];
               }
               return true
            }else if(e.type == 'touchmove'){
               // 判断触发当前事件的触摸点是否有identifier对应的触摸点
               for(let i=0;i < e.changedTouches.length; i++){
                  if(e.changedTouches[i].identifier == this.identifier){
                     currentTouch = e.changedTouches[i];
                     break;
                  }
               }
               if(!currentTouch){
                  return false
               }else{
                  return true
               }
            }else if(e.type == 'touchend' || e.type == 'touchcancel'){
               // 判断触发当前事件的触摸点是否有identifier对应的触摸点
               for(let i=0;i < e.changedTouches.length; i++){
                  if(e.changedTouches[i].identifier == this.identifier){
                     currentTouch = e.changedTouches[i];
                     break;
                  }
               }
               if(currentTouch){
                  this.identifier = null;
                  return true;
               }else{
                  return false;
               }
            }
         }
      },
      onTouchstart(e) {
         // 如果已经有触摸点了，则停止后面的流程
         if(!this.processEvent(e)){
            return
         }
         if(this.dragFlag){
            return
         }
         e.preventDefault();
         // 原点为左上角的初始化移动距离
         this.startX = 0;
         this.startY = 0;
         // 记录准备拖动锁片的初始位移值
         this.curTop = e.target.offsetTop;
         this.curLeft = e.target.offsetLeft;
         // 准备移动的盒子
         let curSpan = document.getElementById(e.targetTouches[0].target.id);
         // 记录当前准备移动盒子的id
         this.wrongId = e.targetTouches[0].target.id;

         this.curSpan = curSpan || this.curSpan;
         /* 屏幕横屏后,浏览器的x,y方向没有改变，原点还是左上角，从手机正常竖屏方向看，pageY为触摸点离顶端的距离,pageX为触摸点离左侧的距离 
            而与元素绑定的相关属性则因为旋转，原点为右上角，从手机横屏方向看，e.target.offsetTop为触摸的盒子离顶部的距离，e.target.offsetLeft为触摸的盒子离左侧的距离
         */
         // 从手机竖屏方向看，触摸点最开始与左侧的距离 = 页面的宽度(可以理解为手机屏幕宽，this.clientWidth) -  触摸点离左侧的距离(e.touches[0].pageX) - 游戏区离顶部的距离(this.boxTopW) - 游戏区上边框值（this.borderW） - 触摸的盒子离顶部的距离(e.target.offsetLeft,原点为右上角)
         this.startX = (this.clientWidth - e.touches[0].pageX - this.boxTopW - this.borderW) - e.target.offsetTop; 
         // 从手机竖屏方向看, 触摸点最开始与顶部的距离 = 触摸点离该页面顶部距离(e.touches[0].pageY) - 游戏区域离顶部的距离((this.clientHeight - this.parentW)/2) - 触摸的盒子离左侧的距离（e.target.offsetLeft，原点为右上角）
         this.startY = e.touches[0].pageY - ((this.clientHeight - this.parentW)/2) - e.target.offsetLeft;
         // 修改移动盒子的层级，保证移动的盒子的层级是页面中最高的
         this.curSpan.style.zIndex = 6;
         let _this = this;

         this.curSpan.removeEventListener('touchmove',_this.onTouchmove)
         this.curSpan.removeEventListener('touchend',_this.onTouchend)
         this.curSpan.addEventListener('touchmove',_this.onTouchmove)
         this.curSpan.addEventListener('touchend',_this.onTouchend)
      },
      onTouchmove(e) {
         e.preventDefault();
         // 如果不是第一个触摸点，则不进行下面的流程
         if(!this.processEvent(e)){
            return
         }
         this.dragFlag = true;
         let target = e.touches[0];
         // 从手机横屏方向看，原点为右上角
         // 左位移 = 触摸点离该页面顶部距离(e.touches[0].pageY) - 游戏区域离左侧的距离((this.clientHeight - this.parentW)/2) - 手指触摸点最初始的与顶部的距离(this.startY)
         let leftX = target.pageY - ((this.clientHeight - this.parentW)/2) - this.startY ;
         // 顶部位移 = 该页面宽度(this.clientWidth) - 触摸点离该页面左侧距离(e.touches[0].pageX) - 游戏区离顶部的距离(this.boxTopW) - 游戏区上边框值（this.borderW） - 手指触摸点最初始的与左侧的距离（this.startX）
         let topY = this.clientWidth - target.pageX -  this.boxTopW - this.borderW - this.startX;
         // 盒子的宽度和高度
         let thisW = target.target.clientWidth;
         let thisH = target.target.clientHeight;

         // 判断移动的最小和最大的位移，并计算最小和最大的位移
         if(leftX <= 0){
            leftX = 0;
         }
         if(leftX >= this.parentW - thisW){
            leftX = this.parentW - thisW;
         }
         if(topY <= 0){
            topY = 0;
         }
         if(topY >= this.parentH - thisH){
            topY = this.parentH - thisH;
         }
         this.curSpan.style.left = leftX+'px';
         this.curSpan.style.top = topY+'px';

         // 目标
         let targetSpan = document.getElementsByClassName(e.touches[0].target.id);

         // 目标以右上角为原点的top和left距离
         this.targetLeft = Number(window.getComputedStyle(targetSpan[0]).left.slice(0,-2)) + ((this.parentW - this.fWidth - this.imgWidth)/3)*2 + this.fWidth;
         this.targetTop = Number(window.getComputedStyle(targetSpan[0]).top.slice(0,-2)) + this.rightTopHeight;// 相当于 top
      },
      onTouchend(e) {
         e.preventDefault();
        if(!this.processEvent(e)){
            return
         }

            let minWidth = ((this.parentW - this.fWidth - this.imgWidth)/3)*2 + this.fWidth; // 完成区离左侧框的距离
            let minHeight = this.rightTopHeight; // 完成区图片离顶部的距离
            let maxHeight = this.imgHeight + minHeight

            // 判断拖动的碎片是否进入目标碎片区域，原理为拖动的锁片与目标的锁片是否有重叠区域
            if((e.target.offsetTop + e.target.clientHeight) >= minHeight &&
            e.target.offsetTop <= maxHeight &&
            (e.target.offsetLeft + e.target.clientWidth) >= minWidth
            ){
               // 碎片进入目标区域的覆盖目标锁片区域的宽度
               let areaHeight = this.imgHeight - Math.abs(e.target.offsetTop - this.targetTop);
               // 碎片进入目标区域的覆盖目标锁片区域的长度
               let areaWidth = this.imgWidth -  Math.abs(e.target.offsetLeft - this.targetLeft);
               // 碎片进入目标区域覆盖的面积是否是80%
               if(areaHeight*areaWidth >= this.imgHeight*this.imgWidth*0.8){
                  this.curSpan.style.left = this.targetLeft + 'px';
                  this.curSpan.style.top = this.targetTop + 'px';
                     // 禁止拖动
                  this.curSpan.style.pointerEvents = 'none';
                  this.dragNum += 1;
               }else{
                  // 拖动的锁片进入目标锁片区域的面积不超过80%，提示Wrong
                  this.wrongShow = true
                  // 倒计时暂停
                  clearInterval(this.timer)
                  // 将拖动的锁片还原到左侧
                  this.curSpan.style.left = this.curLeft + "px";
                  this.curSpan.style.top = this.curTop + "px";

                  let arr = this.wrongId.split("_");
                  let wrongBlock = Number(arr[arr.length - 1]);
                  // 保存错误记录
                  this.saveWrong(wrongBlock)
                  setTimeout(() => {
                     this.wrongShow = false
                     this.countDown()
                  }, 500);
               }
            }else{
               // 如果拖动的锁片没有进入目标锁片区域，则将拖动过来的锁片还原到左侧
               this.curSpan.style.left = this.curLeft + "px";
               this.curSpan.style.top = this.curTop + "px";
            }
            this.curSpan.style.zIndex = 5;
            // 如果左侧所有锁片都放入右侧
            if(this.dragNum == this.gameLevelData.cloumn*this.gameLevelData.row){
               // 保存当前游戏关卡数
               this.saveGameLevel(this.current,true)
               setTimeout(()=>{
                  // 倒计时暂停
                  clearInterval(this.timer)
                  // 如果游戏时间未到，则提示游戏成功
                  if(!this.failShow){
                     this.passedShow = true
                     localStorage.setItem('jigsawSuccessFlag',true)
                  }
               },100)
            }
            // 清空
            this.startX = 0;
            this.startY = 0;
            this.curSpan = null;
            this.targetLeft = 0;
            this.targetTop = 0;
            this.dragFlag = false;

      },
      // 游戏开始
      gameBegin() {
         if(this.timeoutShow){
            return
         }
         this.goActiveFlag = false;
         this.failShow = false
         this.pauseShow = true
         this.gamePauseFlag = false
         this.countDown();
      },
      // 游戏开始/暂停切换
      stateChange() {
         this.gamePauseFlag = true
         clearInterval(this.timer)
         this.pauseShow = false
      },
      // 倒计时
      countDown() {
         let timeArr = this.limitTime.split(":");
         let minute = Number(timeArr[0]); // 分
         let second = Number(timeArr[1]); // 秒
         this.timer = setInterval(()=>{
            second -=1;
            if(second == 0){
               if(minute == 0){
                  setTimeout(()=>{
                     this.failShow = true
                     localStorage.setItem('jigsawSuccessFlag',false)
                     clearInterval(this.timer)
                  },100)
               }else{
                  minute-=1;
                  second = 60
               }
            }
             this.limitTime = minute +":"+ (second < 10 ? '0'+second : second);
         },1000)
      },
      // 返回游戏
      back() {
         this.goBackShow = true;
         clearInterval(this.timer)
      },
      // 下一关
      next() {
         // this.$refs.go.play();
         this.passedShow = false;
         this.dragFlag = false;
         this.current = Number(this.current);
         this.current+= 1;
         localStorage.setItem('jigsawLevel',this.current)
         localStorage.setItem('jigsawSuccessFlag',true)

         this.getInit();
         // this.$refs.bgmusic.play();
         this.goActiveFlag = true;
         this.$emit('next')
         // let rows = this.gameLevelData[this.localIndex];
         // this.addImg(rows);
         // this.$refs.go.play();
         // this.goActiveFlag = true;
      },
      // 重新开始
      restart() {
         // this.$refs.go.play();
         this.failShow = false
         this.pauseShow = true
         this.gamePauseFlag = false
         this.dragFlag = false;
         this.getInit()
         // this.$refs.bgmusic.play();
         this.goActiveFlag = true;
         localStorage.setItem('jigsawSuccessFlag',false)
         this.$emit('restart')
         // this.timeRemap()
         // this.$refs.go.play();
         // this.goActiveFlag = true;
      },
      // 返回关卡页面
      goBack() {
         // this.$router.push('jigsawIndex');
         this.queryGameEnd();
         clearInterval(this.timer);
         clearInterval(this.intervalTimer);
         let levelPassedFlag = this.passedShow ? true : false;
         localStorage.setItem('jigsawSuccessFlag',levelPassedFlag);
         this.$emit('goIndex')
         // let successFlag = this.passedShow ? true : false

         // localStorage.setItem('jigsawSuccessFlag',successFlag)
      },
      // 返回提醒的关闭
      infoClose() {
         this.goBackShow = false;
         this.countDown()
      },
      // 每一小块中增加背景图 interval:间隔为10px
      addImg(rows) {
         this.isMoveShow = []
         let rowList = this.getRandom(rows.row,rows.cloumn).rowList;
         let cloumnList = this.getRandom(rows.row,rows.cloumn).cloumnList;
          // 图片的宽度
         this.imgWidth = Number(window.getComputedStyle(document.getElementsByClassName('area_img')[0]).width.slice(0,-2));
         // 图片的高度
         this.imgHeight = Number(window.getComputedStyle(document.getElementsByClassName('area_img')[0]).height.slice(0,-2));
         // 完成区下面的图片大盒子
         let yuansuRight = document.getElementsByClassName("jigsaw_bottom_game_right_area");
         // 完成区的盒子
         let choiceTopRight = document.getElementsByClassName("jigsaw_bottom_game_title");
         // 完成区下面图片与游戏区域顶部之间的距离
         this.rightTopHeight = Number(window.getComputedStyle(choiceTopRight[0]).marginTop.slice(0,-2)) + Number(window.getComputedStyle(yuansuRight[0]).marginTop.slice(0,-2)) + Number(window.getComputedStyle(choiceTopRight[1]).height.slice(0,-2));
         // 选择区下面的图片盒子
         let yuansuLeft = document.getElementsByClassName("jigsaw_bottom_game_left_area");
         // 选择区的盒子
         let choiceTopLeft = document.getElementsByClassName("jigsaw_bottom_game_title");
         // 选择区下面图片与游戏区域顶部之间的距离
         this.leftTopHeight = Number(window.getComputedStyle(choiceTopLeft[0]).marginTop.slice(0,-2)) + Number(window.getComputedStyle(yuansuLeft[0]).marginTop.slice(0,-2)) + Number(window.getComputedStyle(choiceTopLeft[0]).height.slice(0,-2))
         // 完成区下面图片盒子的宽度
         this.fWidth = Number(window.getComputedStyle(document.getElementsByClassName('jigsaw_bottom_game_left_area')[0]).width.slice(0,-2))
         
         for(let i=0; i < rowList.length; i++){
            let arr = [];
            for(let j=0; j < cloumnList.length; j++){
                this.$nextTick(()=>{
                  this.isMoveShow.push(false)
                  // 左侧碎片
                  let curSpan = document.getElementById('cloumn_'+(rowList[i]+1)+(cloumnList[j]+1));
                  // 右侧完成区的锁片
                  let rightSpan = document.getElementsByClassName('cloumn_'+(i+1)+(j+1));
                  
                  curSpan.style.background = "url("+rows.img+") no-repeat scroll";
                  curSpan.style.backgroundSize = this.imgWidth+'px '+this.imgHeight+'px';

                  // 根据关卡动态给左侧锁片的长宽赋值
                  curSpan.style.width = (this.imgWidth/rows.cloumn)+'px';
                  curSpan.style.height = (this.imgHeight/rows.row)+'px';

                  // 将左侧锁片最近摆放
                  curSpan.style.backgroundPosition = this.getInverse(cloumnList[j]*(this.imgWidth/rows.cloumn))+'px '+this.getInverse(rowList[i]*(this.imgHeight/rows.row))+'px';

                  curSpan.style.top = (i*(this.imgHeight/rows.row) + this.leftTopHeight + i*10) +'px';
                  curSpan.style.left = (this.parentW - this.fWidth - this.imgWidth)/3 + (j*(this.imgWidth/rows.cloumn)) + j*10 +'px';
                  // 右侧锁片的位置按顺序摆放
                  rightSpan[0].style.top = i*(this.imgHeight/rows.row) + 'px';
                  rightSpan[0].style.left = j*(this.imgWidth/rows.cloumn) + 'px';

                  curSpan.style.pointerEvents = 'auto';

               })

            }
         }
      },
      // 生成随机数
      getRandom(row,cloumn) {
         let rowList = [];
         let cloumnList = [];
         for(let i=0; i < row; i++){
            rowList.push(i);
         }
         for(let j=0; j < cloumn; j++){
            cloumnList.push(j);
         }

         rowList = rowList.sort(this.sortNumber);

         cloumnList = cloumnList.sort(this.sortNumber);

         return {rowList:rowList,cloumnList:cloumnList};
      },
      // 随机排序
      sortNumber(a,b) {
         return Math.random() - 0.8;
      },
      // 取相反数
      getInverse(num) {
         return (0 - num);
      },


   },
}
</script>

<style lang="scss" scoped>
.jigsaw{
   width:100%;
   height:100%;
   background: url("../../assets/images/jigsaw/background.png") no-repeat;
   background-size: cover;
   position: relative;
   ::v-deep .van-overlay{
      z-index:8;
   }
   #bgmusic{
      display:none;
   }
   .word-go {
      position: absolute;
      width: 100%;
      display: block;
      color: red;
      text-align: center;
      transform: scale(0);
      opacity: 0;
      line-height: 400px;
      z-index: 9999999999;
   }
   .goActive {
      animation: goSlide 1.5s 0s;
   }
   @keyframes goSlide {
      from {
            opacity: 0;
            transform: scale(0);
      }
      to {
            transform: scale(1.7);
            opacity: 1;
      }
   }
   .jigsaw_top{
      display: flex;
      position: relative;
      width:calc(100% - 35px);
      justify-content: space-between;
      flex-wrap: nowrap;
      // overflow: hidden;
      .jigsaw_top_left{
         display: flex;
         justify-content: space-between;
         width:26.53%;
         // width:calc(100% - 490px);
      }
      .jigsaw_top_back{
         width:29px;
         height:29px;
         margin:15px 0 0 15px;
      }
      .jigsaw_top_guanqia{
         display: inline-block;
         width:74px;
         height:64px;
         // margin-left:0.09;
         background: url("../../assets/images/jigsaw/local-level.png") no-repeat;
         background-size: cover;
         color:#fff;
         font-family: PingFangSC-Regular, PingFang SC;
         .jigsaw_top_guanqia_title{
            width:100%;
            height:17px;
            margin-top: 7px;
            font-size: 12px;
            font-weight: 400;
            line-height:17px;
            text-align: center;
         }
         .jigsaw_top_guanqia_level{
            font-size: 16px;
            font-weight: 600;
            width:17px;
            height:22px;
            width:100%;
            // margin:0 28px;
            line-height:22px;
            text-align: center;
         }
      }
      .jigsaw_top_right{
         display: flex;
         // width:calc(100% - 167px);
         width:68.215%;
         justify-content: space-between;
      }
      .jigsaw_top_times{
         display: flex;
      }
      .jigsaw_top_rules{
         width:auto;
         // margin-left:35px;
         display: flex;
         .jigsaw_top_rules_title{
            display:inline-block;
            min-width:251px;
            height:40px;
            background: url("../../assets/images/jigsaw/frame.png") no-repeat;
            background-size: 100% 100%;
            font-size:14px;
            font-weight: 400;
            color:#666;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height:40px;
            padding:0 24px 0 12px;
            margin-top:16px;
            vertical-align: middle;
            box-sizing: border-box;
            .jigsaw_emotion{
               color:#FF8340;
               font-size:16px;
            }
         }
         .jigsaw_top_rules_pic{
            display:inline-block;
            vertical-align: middle;
            width:36px;
            height:52px;
            margin:7px 0 0 4px;
            background: url("../../assets/images/jigsaw/cartoon.png") no-repeat;
            background-size: 100% 100%;
         }
      }

      .jigsaw_top_switch{
         width:22px;
         height:22px;
         // position:absolute;
         // right:107px;
         // top:25px;
         // margin:25px 0 0 35px;
         margin-top:25px;
      }
      .jigsaw_top_time{
         // position:absolute;
         // right:35px;
         // top:15px;
         width:62px;
         height:42px;
         line-height:42px;
         margin:15px 0 0 10px;
         font-size:30px;
         color:#fff;
         font-family: PingFangSC-Regular, PingFang SC;
      }
   }
   .jigsaw_bottom{
      border-radius: 16px;
      width:calc(100%);
      padding:0 30px;
      .jigsaw_bottom_game{
         // width:607px;
         width:100%;
         height:280px;
         border-radius: 16px;
         border:5px solid #FF8340;
         margin:0 auto;
         position: relative;
         box-sizing: border-box;
         background: rgba(255,255,255,0.49);
         display:flex;
         justify-content: space-evenly;
          .jigsaw_bottom_game_title{
               width:54px;
               height:24px;
               line-height:24px;
               border:1px solid #FF8340;
               border-radius:3px;
               font-size:14px;
               color:#FF8340;
               background: #fff;
               text-align: center;

            }
         .jigsaw_bottom_game_left{
            // width:50%;
            height:100%;
            &.one{
               .jigsaw_bottom_game_title{
                   margin:15px auto 0;
               }
               .jigsaw_bottom_game_left_area{
                  margin-top:18px;
               }
            }
            &.two{
               .jigsaw_bottom_game_title{
                   margin:19px auto 0;
               }
               .jigsaw_bottom_game_left_area{
                  margin-top:25px;
               }
            }
            &.three{
               .jigsaw_bottom_game_title{
                   margin:19px auto 0;
               }
               .jigsaw_bottom_game_left_area{
                  margin-top:33px;
               }
            }
            &.four{
               .jigsaw_bottom_game_title{
                   margin:11px auto 0;
               }
               .jigsaw_bottom_game_left_area{
                  margin-top:10px;
               }
            }
            .jigsaw_bottom_game_left_dragging{
               margin:0 auto;
               display: flex;
               flex-wrap: wrap;
               justify-content: space-between;
               line-height:0;
               font-size:0;
               .finished_row{
                  display: flex;
                  justify-content: space-between;
                  &:not(:last-child){
                     margin-bottom:10px;
                  }
               }
               .finished_cloumn{
                  display: inline-block;
                  background: #fff;
                  position:absolute;
                  z-index:5;
               }
            }
            // 1~4关
            .jigsaw_bottom_game_left_area_one{
               // margin-top:18px;
               width:200px;
               height:200px;
               // background: #FF8340;
               .finished_row{
                  width:200px;
                  height:60px;

               }
               .finished_cloumn{
                  width:60px;
                  height:60px;
               }
            }
            // 5~8关
            .jigsaw_bottom_game_left_area_two{
               width:230px;
               height:170px;
               .finished_row{
                  width:230px;
                  height:50px;
               }
               .finished_cloumn{
                  width:50px;
                  height:50px;
               }
            }
            // 9~12关
            .jigsaw_bottom_game_left_area_three{
               width:265px;
               height:155px;
               .finished_row{
                  width:265px;
                  height:45px;
               }
               .finished_cloumn{
                  width:45px;
                  height:45px;
               }
            }
            // 13~16关
            .jigsaw_bottom_game_left_area_four{
               width:265px;
               height:210px;
               .finished_row{
                  width:265px;
                  height:45px;
               }
               .finished_cloumn{
                  width:45px;
                  height:45px;
               }
            }
         }
         .jigsaw_bottom_game_right{
            // width:50%;
            height:100%;
            text-align: center;
             &.one{
                .area_img{
                  width:180px;
                  height:180px;

                  &.emotion1{
                     background:url('../../assets/images/jigsaw/one.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion2{
                     background:url('../../assets/images/jigsaw/sorrow1.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion3{
                     background:url('../../assets/images/jigsaw/scare1.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion4{
                     background:url('../../assets/images/jigsaw/anger1.png') no-repeat;
                     background-size:cover;
                  }
               }
               .jigsaw_bottom_game_title{
                   margin:15px auto 0;
               }
               .jigsaw_bottom_game_right_area{
                  margin-top:28px;
               }
            }
            &.two{
               .area_img{
                  width:200px;
                  height:150px;
                  &.emotion1{
                     background:url('../../assets/images/jigsaw/happy2.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion2{
                     background:url('../../assets/images/jigsaw/sorrow2.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion3{
                     background:url('../../assets/images/jigsaw/scare2.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion4{
                     background:url('../../assets/images/jigsaw/anger2.png') no-repeat;
                     background-size:cover;
                  }
               }
               .jigsaw_bottom_game_title{
                   margin:19px auto 0;
               }
               .jigsaw_bottom_game_right_area{
                  margin-top:35px;
               }
            }
            &.three{
               .area_img{
                  width:225px;
                  height:135px;
                  background-size:cover;
                  &.emotion1{
                     background:url('../../assets/images/jigsaw/happy3.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion2{
                     background:url('../../assets/images/jigsaw/sorrow3.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion3{
                     background:url('../../assets/images/jigsaw/scare3.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion4{
                     background:url('../../assets/images/jigsaw/anger3.png') no-repeat;
                     background-size:cover;
                  }
               }
               .jigsaw_bottom_game_title{
                   margin:19px auto 0;
               }
               .jigsaw_bottom_game_right_area{
                  margin-top:43px;
               }
            }
            &.four{
               .area_img{
                  width:225px;
                  height:180px;
                  background-size:cover;
                  &.emotion1{
                     background:url('../../assets/images/jigsaw/happy4.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion2{
                     background:url('../../assets/images/jigsaw/sorrow4.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion3{
                     background:url('../../assets/images/jigsaw/scare4.png') no-repeat;
                     background-size:cover;
                  }
                  &.emotion4{
                     background:url('../../assets/images/jigsaw/anger4.png') no-repeat;
                     background-size:cover;
                  }
               }
               .jigsaw_bottom_game_title{
                   margin:11px auto 0;
               }
               .jigsaw_bottom_game_right_area{
                  margin-top:25px;
               }
            }
            .jigsaw_bottom_game_right_area{
               position: relative;
            }

            .jigsaw_bottom_game_right_place{
               position: absolute;
               top:0;
               left:50%;
               background: rgba(255,225,225,0.49);
               border-radius: 16px;
               z-index:1;
               .finished_row{
                  font-size:0;
                  // box-sizing: border-box;
                  &:not(:last-child){
                     box-sizing: border-box;
                     border-bottom:2px solid #FF8340;
                     opacity: 0.49;
                  }
               }
               .finished_cloumn{
                  display: inline-block;
                  position: absolute;
                  // background: rgba(255,255,255,0.49);
                  &:not(:last-child){
                     box-sizing: border-box;
                     border-right:2px solid #FF8340;
                     opacity: 0.49;

                  }
               }
            }
            // 1~4关
            .jigsaw_bottom_game_right_area_one{

               width:180px;
               height:180px;
               margin-left:-90px;
               .finished_row{
                  width:180px;
                  height:60px;
               }
               .finished_cloumn{
                  width:60px;
                  height:60px;

               }

            }
            // 5~8关
            .jigsaw_bottom_game_right_area_two{
               width:200px;
               height:150px;
               margin-left:-100px;
               .finished_row{
                  width:200px;
                  height:50px;
               }
               .finished_cloumn{
                  width:50px;
                  height:50px;
               }
            }
            // 9~12关
            .jigsaw_bottom_game_right_area_three{
               width:225px;
               height:135px;
               margin-left:-112.5px;
               .finished_row{
                  width:225px;
                  height:45px;
               }
               .finished_cloumn{
                  width:45px;
                  height:45px;
               }
            }
            // 13~16关
            .jigsaw_bottom_game_right_area_four{
               width:225px;
               height:180px;
               margin-left:-112.5px;
               .finished_row{
                  width:225px;
                  height:45px;
               }
               .finished_cloumn{
                  width:45px;
                  height:45px;
               }
            }
         }
      }
   }
}
</style>
